import React from 'react';

export const useCombinedRefs = <T extends HTMLElement>(
  ...refs: (React.ForwardedRef<T> | React.MutableRefObject<T>)[]
) => {
  const targetRef = React.useRef<T | null>(null);

  React.useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};
